let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ky86")).then(() => parcelRequire('kTbfK'));